export default __webpack_public_path__ + "static/media/img3.51100043.png";